import { resolveProfileType } from './resolveProfileType';

interface SurveySubmission {
  id?: string;
  full_name?: string;
  profile_name?: string | null;
  scores?: any;
  assessment_variant?: string | null;
}

/**
 * Generate profile name with "The" prefix — always recalculated from scores (canonical logic).
 * Falls back to DB profile_name only when scores are missing/unparseable.
 */
export const generateProfileName = (submission: SurveySubmission): string => {
  if (submission.scores) {
    const profileType = resolveProfileType(submission);
    return `The ${profileType}`;
  }

  // Fallback: no scores available, trust DB
  if (submission.profile_name) {
    return submission.profile_name.startsWith('The ')
      ? submission.profile_name
      : `The ${submission.profile_name}`;
  }

  return 'The Professional';
};

/**
 * Generate just the type name without "The" prefix — always recalculated from scores.
 * Falls back to DB profile_name only when scores are missing/unparseable.
 */
export const generateProfileType = (submission: SurveySubmission): string => {
  if (submission.scores) {
    return resolveProfileType(submission);
  }

  // Fallback: no scores available, trust DB
  if (submission.profile_name) {
    return submission.profile_name.startsWith('The ')
      ? submission.profile_name.substring(4)
      : submission.profile_name;
  }

  return 'Professional';
};

// Keep generateDiscCode for backwards compatibility but it's no longer the canonical path
export { resolveProfileType as generateDiscCode };
export { resolveProfileType as getDiscCode };
